import EmploymentFormAddPage from './EmploymentFormAddPage';

export default EmploymentFormAddPage;
